import React, {ReactNode} from 'react'
import FacilityOptionInputForm, {OptionSetting} from './FacilityOptionInputForm'
import FacilityOptionList from './FacilityOptionList'
import {Nullable} from '../../../../app/TypeHelpers'
import {Dialog} from '@mui/material'
import {AdminDefaultMediumButton} from '../../../../styledComponents/adminPage/Buttons'
import {RENTAL_TYPE} from '../../../../CodeMaster'
import equal from 'fast-deep-equal'
import EventEmitterExAdmin from '../../../shared/pageBaseComponents/EventEmitterExAdmin'

interface FacilityOptionSettingProps {
    options: OptionSetting[]
    stayAvailability: RENTAL_TYPE
    eventEmitter: EventEmitterExAdmin
    onUpdateOptions: (options: OptionSetting[]) => void
}

interface State {
    dialogOpen: boolean
    editTargetOptionLocalId: Nullable<string>
}

export default class FacilityOptionSetting extends React.Component<FacilityOptionSettingProps, State> {

    constructor(props: Readonly<FacilityOptionSettingProps>) {
        super(props)
        this.state = {
            dialogOpen: false,
            editTargetOptionLocalId: null,
        }

        this.handleOpenOptionSettingDialog = this.handleOpenOptionSettingDialog.bind(this)
        this.handleCancelOptionSetting = this.handleCancelOptionSetting.bind(this)
        this.handleAddOptionSetting = this.handleAddOptionSetting.bind(this)
        this.handleDeleteOption = this.handleDeleteOption.bind(this)
        this.handleUpdateOption = this.handleUpdateOption.bind(this)
    }

    shouldComponentUpdate(nextProps: Readonly<FacilityOptionSettingProps>, nextState: Readonly<State>): boolean {
        return !(
            (this.props === nextProps || equal(this.props, nextProps))
            && (this.state === nextState || equal(this.state, nextState))
        )
    }

    handleOpenOptionSettingDialog(): void {
        this.setState({editTargetOptionLocalId: null}, () => {
            this.setState({dialogOpen: true})
        })
    }

    handleCancelOptionSetting(): void {
        this.setState({dialogOpen: false})
    }

    handleAddOptionSetting(optionSetting: OptionSetting): void {
        this.setState({dialogOpen: false}, () => {
            this.props.onUpdateOptions(
                [...this.props.options, optionSetting],
            )
        })
    }

    handleUpdateOptionSetting = (localId: string) => (optionSetting: OptionSetting): void => {
        this.setState({dialogOpen: false}, () => {
            const {options} = this.props
            this.props.onUpdateOptions(
                options.map(option => (option.localId === localId) ? optionSetting : option),
            )
        })
    }

    handleDeleteOption(localId: string): void {
        this.props.onUpdateOptions(
            this.props.options.filter((option) => option.localId !== localId),
        )
    }

    handleUpdateOption(localId: string): void {
        this.setState({editTargetOptionLocalId: localId}, () => {
            this.setState({dialogOpen: true})
        })
    }

    render(): ReactNode {
        return <>
            <Dialog
                id={'pp-dialog'}
                open={this.state.dialogOpen}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                fullWidth
            >
                {
                    (this.state.editTargetOptionLocalId !== null)
                        ? <FacilityOptionInputForm
                            optionSetting={
                                this.props.options.find(
                                    option => option.localId === this.state.editTargetOptionLocalId,
                                ) || null
                            }
                            stayAvailability={this.props.stayAvailability}
                            onSubmit={this.handleUpdateOptionSetting(this.state.editTargetOptionLocalId)}
                            onCancel={this.handleCancelOptionSetting}
                        />
                        : <FacilityOptionInputForm
                            optionSetting={null}
                            stayAvailability={this.props.stayAvailability}
                            onSubmit={this.handleAddOptionSetting}
                            onCancel={this.handleCancelOptionSetting}
                        />
                }
            </Dialog>
            <div>
                <AdminDefaultMediumButton
                    onClick={this.handleOpenOptionSettingDialog}
                    size={'small'}
                >
                    オプション追加
                </AdminDefaultMediumButton>
            </div>
            {
                (this.props.options.length > 0) &&
                <FacilityOptionList
                    options={this.props.options}
                    eventEmitter={this.props.eventEmitter}
                    onRequestDeleteOption={this.handleDeleteOption}
                    onRequestUpdateOption={this.handleUpdateOption}
                />
            }
        </>
    }
}
